import type { UserRow } from '../userViewModel';

import UserAvatar from './UserAvatar';

interface FhBackfillCardProps {
  user: UserRow;
}

/** Inline card describing the imported staff record an invite will bind. */
export default function FhBackfillCard({ user }: FhBackfillCardProps) {
  return (
    <div className="p-3 rounded-lg border border-[#FAC775] bg-[#FAECD8] dark:border-[#7A5A22] dark:bg-[#33260F]">
      <div className="text-[9.5px] font-bold tracking-wider uppercase text-[#BA7517] dark:text-[#F0C97D] mb-2">
        FareHarbor staff record found
      </div>
      <div className="flex items-center gap-2.5">
        <UserAvatar name={user.name} size={36} />
        <div className="flex-1 min-w-0">
          <div className="text-[13px] font-bold text-bark-900 dark:text-[#e8ece9]">{user.name}</div>
          <div className="text-[11px] text-stone-600 dark:text-stone-400">
            {user.upcomingWorkshops} upcoming workshops
          </div>
          {user.fareharborUsername && (
            <div className="text-[10.5px] text-stone-500 dark:text-stone-400 font-mono mt-0.5">
              {user.fareharborUsername}
            </div>
          )}
        </div>
      </div>
      <div className="mt-2.5 pt-2.5 border-t border-dashed border-[#BA7517]/30 dark:border-[#F0C97D]/25 text-[11px] text-bark-800 dark:text-[#e8ece9] leading-snug">
        <strong>What happens:</strong> this record gets the email you typed and the sign-in account
        is bound to it, then the invite is sent. No duplicate row is created.
      </div>
    </div>
  );
}
